import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { EditAddLinkedTemplatePopupComponent } from '../../../linked-templates/edit-add-linked-template-popup/edit-add-linked-template-popup.component';
import { ReminderCreationFormComponent } from './reminder-creation-form/reminder-creation-form.component';
import { Subscription } from 'rxjs';
import { CommonService, DocumentService, UserService } from '@app/shared/services';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { EventNames, EVENTS } from '@app/constants/events.constants';
import { AnimationOptions } from 'ngx-lottie';
import { ReminderTitleName } from './../../../../../../../shared/pipes/reminder-title-name.pipe';
import { ChecklistTaskComponent } from '@app/shared/component/checklist-task/checklist-task.component';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { ChecklistService } from '@app/shared/services/checklist/checklist.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-edit-reminder-model',
  templateUrl: './add-edit-reminder-model.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEditReminderModelComponent implements OnInit, OnDestroy {
  private reminderTitleNamePipe = new ReminderTitleName();
  @Input() inlineComponent = false;
  @Input() inlinedata;
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];
  dialogRef;
  userId;
  reminder_configurations_list;
  currentFormId;
  form_id;
  is_loading = true;
  createReminder = false;
  reminderList = [];
  formValue;
  triggerTypeList = [];
  reminderItems;

  reminderConfigJsonData = [];

  subscription = new Subscription();
  myForm = new FormGroup({
    name: new FormControl(false),
  });
  linkedTasks: any = [];
  addedReminder: any;
  formatted_reminder_list: any[] = [];

  reminderLoadingDone() {
    this.is_loading = false;
    this.cd.detectChanges();
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private _userService: UserService,
    private documentService: DocumentService,
    private commonService: CommonService,
    private injector: Injector,
    private checklistTaskService: ChecklistTaskService,
    private checklistService: ChecklistService
  ) {}
  closeDialog() {
    this.dialogRef.close();
  }

  getItemSetupList() {
    this.subscription.add(
      this.documentService.getItemsToSetUpList(this.userId, this.currentFormId).subscribe((res) => {
        if (res.findIndex((x) => x.type == 'reminder') >= 0) {
          this.reminderItems = res.find((x) => x.type == 'reminder');
          let status = res.find((x) => x.type == 'reminder').status;
          this.myForm.controls.name.setValue(status == 'created' ? false : true);
        }
        this.cd.detectChanges();
      })
    );
  }

  createReminderEvent() {
    this.CreateReminderAction();
  }
  editReminder(items) {
    this.CreateReminderAction(items);
  }

  createReminderWithSuggestionEvent(event) {
    this.addedReminder = event.suggestedReminderAdded;
    let title = event.label?.trim()?.toLowerCase();
    let prePopulateData = [];
    if (this.reminderConfigJsonData[1].config.filter((x) => x.type?.trim()?.toLowerCase() == title).length > 0) {
      prePopulateData = [
        {
          title: title,
          display_text: event.display_text,
          display_subtext: event.display_subtext,
          reminder_type: this.reminderConfigJsonData[1].type,
          config: this.reminderConfigJsonData[1].config.filter((x) => x.type?.trim()?.toLowerCase() == title),
        },
      ];
    } else if (this.reminderConfigJsonData[0].config.filter((x) => x.type?.trim()?.toLowerCase() == title).length > 0) {
      prePopulateData = [
        {
          title: title,
          display_text: event.display_text,
          display_subtext: event.display_subtext,
          reminder_type: this.reminderConfigJsonData[0].type,
          config: this.reminderConfigJsonData[0].config.filter((x) => x.type?.trim()?.toLowerCase() == title),
        },
      ];
    }
    this.CreateReminderAction(null, prePopulateData);
  }
  CreateReminderAction(items = null, prePopulateData = null) {
    this.createReminder = true;
    this.cd.detectChanges();
    let suggestion_type = '';
    if (prePopulateData != null && prePopulateData.length > 0) {
      suggestion_type = prePopulateData[0].title;
    }
    const dialogRef = this.dialog.open(ReminderCreationFormComponent, {
      data: {
        currentFormId: this.data.currentFormId,
        items,
        prePopulateData,
        suggestion_type,
        form_id: this.form_id,
        triggerTypeList: this.triggerTypeList,
        formValue: this.formValue,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.createReminder = false;
        const eventSource = this.inlineComponent ? 'setup' : 'view';
        this.trackEventsInMixPanel([
          { eventName: items ? EVENTS[`template_${eventSource}_edit_reminder`] : EVENTS[`template_${eventSource}_add_reminder`] },
        ]);
        this.getReminderListForCurrentForms();
        this.cd.detectChanges();
      })
    );
    this.cd.detectChanges();
  }
  ngOnInit(): void {
    if (this.inlineComponent) {
      this.data = this.inlinedata;
    } else {
      this.dialogRef = this.injector.get(MatDialogRef<EditAddLinkedTemplatePopupComponent>);
    }
    this.userId = this.data.userId;
    this.formValue = this.data.formValue;
    this.currentFormId = this.data.currentFormId;
    this.getItemSetupList();
    this.getReminderListForCurrentForms();
    this.getChecklistTasksLinkedWithForms();
    this.reminder_configurations_list = this.data.reminder_configurations_list;

    this.triggerTypeList = this.data.triggerTypeList;

    this.form_id = this.data.form_id;
    this.subscription.add(
      this.myForm.controls.name.valueChanges.subscribe((res) => {
        if (this.reminderItems?.id) {
          this.subscription.add(
            this.documentService
              .updateItemsToSetUpList({
                id: this.reminderItems.id,
                status: res ? 'complete' : 'created',
                setupLabel: 'Checklist',
              })
              .subscribe((res) => {})
          );
        }
      })
    );

    this.getReminderConfigData();
  }
  getReminderConfigData() {
    this.subscription.add(
      this.commonService.getReminderConfigJSON().subscribe((res) => {
        this.reminderConfigJsonData = res;
        this.cd.detectChanges();
      })
    );
  }
  checkFormattedReminderList() {
    if (this.addedReminder) {
      this.subscription.add(
        this.documentService
          .updateItemsToSetUpList({
            id: this.reminderItems.id,
            status: 'complete',
            setupLabel: 'Checklist',
          })
          .subscribe()
      );
    }
  }

  // Modify the getReminderListForCurrentForms method to call checkFormattedReminderList
  getReminderListForCurrentForms() {
    this.subscription.add(
      this.documentService.getReminderList(this.userId, this.currentFormId).subscribe(
        (res) => {
          this.reminderList = res;
          this.checkFormattedReminderList(); // Add this line
          this.cd.detectChanges();
        },
        (error) => {}
      )
    );
  }
  getChecklistTasksLinkedWithForms() {
    this.subscription.add(
      this.checklistTaskService.getChecklistTasksLinkedWithForms(this.userId, this.currentFormId).subscribe((res) => {
        this.linkedTasks = res;
        this.cd.detectChanges();
      })
    );
  }
  deleteReminder(edit) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Delete Reminder',
        materialIcon: 'delete',
        text: `Are you sure you want to delete the reminder ${this.reminderTitleNamePipe.transform(
          edit.title,
          this.formValue,
          edit
        )}? You can't undo this action.`,
        proceedTitle: 'Delete',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService.deleteReminder(this.userId, edit.id).subscribe(
              (res) => {
                const eventSource = this.inlineComponent ? 'setup' : 'view';
                this.trackEventsInMixPanel([{ eventName: EVENTS[`template_${eventSource}_delete_reminder`] }]);
                this.getReminderListForCurrentForms();
              },
              (error) => {}
            )
          );
        }
      })
    );
  }
  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }
  addTask() {
    const taskDialogRef = this.dialog.open(ChecklistTaskComponent, {
      width: 'auto',
      height: 'auto',
      data: {
        mode: 'add',
        isCustom: false,
        groupName: '',
        templateData: this.data.templateData,
        manageTask: true,
      },
    });
    this.subscription.add(
      taskDialogRef.afterClosed().subscribe(() => {
        this.getChecklistTasksLinkedWithForms();
        const eventSource = this.inlineComponent ? 'setup' : 'view';
        this.trackEventsInMixPanel([{ eventName: EVENTS[`template_${eventSource}_add_task`] }]);
        this.cd.detectChanges(); // Force update to refresh UI
      })
    );
  }
  editTask(task) {
    const dialogRef = this.dialog.open(ChecklistTaskComponent, {
      height: '100%',
      panelClass: 'full-window-dialog',
      data: {
        taskId: task.id,
        mode: 'edit',
        isCustom: false,
        groupName: '',
        manageTask: true,
      },
      autoFocus: false,
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe(() => {
        const eventSource = this.inlineComponent ? 'setup' : 'view';
        this.trackEventsInMixPanel([{ eventName: EVENTS[`template_${eventSource}_edit_task`] }]);
        this.getChecklistTasksLinkedWithForms();
        this.cd.detectChanges();
      })
    );
  }
  deleteTask(task) {
    const payload = {
      userId: this.userId,
      reminders: [],
      tasks: [task.id],
    };
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `This action cannot be undone, are you sure you want to delete this item?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.checklistService.deleteChecklistItems(payload).subscribe((res) => {
              if (res.status === 200) {
                const eventSource = this.inlineComponent ? 'setup' : 'view';
                this.trackEventsInMixPanel([{ eventName: EVENTS[`template_${eventSource}_delete_task`] }]);
                this.getChecklistTasksLinkedWithForms();
                this.cd.detectChanges();
              }
            })
          );
        }
      })
    );
  }
  onToggleChange(event: any) {
    if (event.checked) {
      this.closeDialog();
    }
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
  onFormattedListChange(list: any[]) {
    this.formatted_reminder_list = list;
    this.cd.detectChanges();
  }
}
